import { typography } from '@moda/tokens';

export const remToUnitlessPx = (value: string) =>
  parseFloat(value) * parseInt(typography['root-font-size'], 10);
